var render = function render(){var _vm=this,_c=_vm._self._c;return _c('n-grid',[_c('n-text',{staticClass:"span-5",attrs:{"preset":"sub","color":"warning"}},[_vm._v(_vm._s(_vm.$t('tripDetails.outsideSponsoredArea.note')))]),_c('n-column',{staticClass:"column"},[_c('n-help',{on:{"click":_vm.trigger}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }